// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import type { ButtonProps } from "@aviary/components/Button";
import { Button } from "@aviary/components/Button";
import { l } from "@aviary/locales/i18n";

import { useCarouselContext } from "../CarouselContext";

/** @deprecated Please use NewCarousel instead */
const CarouselNext = ({ children, ...rest }: ButtonProps) => {
  const { t } = useTranslation();

  const {
    activeIndex,
    setActiveIndex,
    carouselItemsCount,
    loop,
    setDirection,
    itemsToShow,
    itemsToScroll,
  } = useCarouselContext();

  const nextOnClick = (): void => {
    const nextFirstItemIndex = activeIndex + itemsToScroll;
    if (nextFirstItemIndex < carouselItemsCount) setActiveIndex(nextFirstItemIndex);
    if (loop && nextFirstItemIndex >= carouselItemsCount) {
      setActiveIndex(nextFirstItemIndex - carouselItemsCount);
    }
    setDirection("right");
  };

  const isDisabled: boolean = !loop && activeIndex + itemsToShow >= carouselItemsCount;

  if (itemsToShow === carouselItemsCount) return null;

  return (
    <Button
      onClick={nextOnClick}
      disabled={isDisabled}
      aria-label={t(l.aviary.carousel.next)}
      isText
      isColor="system"
      {...rest}
    >
      {children}
    </Button>
  );
};

export { CarouselNext };
